import Component from "../../../../js/assets/component.js"
import Device from "../../../../js/assets/device.js"
import SlideShowBody from "./slideshow_body.js"
import SlideShowThumbnail from "./slideshow_thumbnail.js"

class SlideShow extends Component {
  constructor(el){
    super(el);
  }

  data(){
    return {
      "SLIDE_TOTAL_NUM": null,
      "AUTO_SLIDE_INTERVAL": 10000,
      // "AUTO_SLIDE_INTERVAL": 3000,
      "activeIndex": null,
      "slideDir": "left",
      "isPauseTimer": null,
      "device_mode": null,
      "autoSlide": null,
      "AUTO_SLIDE_INTERVAL_COUNT_STEP": 200,
      "autoSlideIntervalCount": 0
    }
  }

  changed(){
    return {
      "SLIDE_TOTAL_NUM": () => {
        this.noChange('SLIDE_TOTAL_NUM')
      },
      "activeIndex": async (index, prev) => {
        //disable activeIndex change
        this.noChange('activeIndex')
        //stop auto slide timer
        this.clearAutoSlideTimer()
        //activate slide item
        this.slideBody.$data.activeIndex = index
        this.thumbnail.$data.activeIndex = index
        //reset auto slide count
        this.resetAutoSlideCount()
        //wait
        await this.wait(500)
        //start auto slide timer
        this.startAutoSlideCount()
        this.startAutoSlideTimer()
        // enable activeIndex change
        this.canChange('activeIndex')
      },
      "slideDir": (val, prev) => {
        // console.log(val, prev)
        this.slideBody.$data.slideDir = val
      },
      "isPauseTimer": (val) => {
        if(val === true){
          this.pauseAutoSlide()
        }else{
          this.resumeAutoSlide()
        }
      },
      "device_mode": (val) => {
      },
      "autoSlideIntervalCount": (val) => {
        let plus = 0
        if(val !== 0){
          plus = this.$data.AUTO_SLIDE_INTERVAL_COUNT_STEP
        }
        let per = ((val + plus)/this.$data.AUTO_SLIDE_INTERVAL)*100
      }
    }
  }

  async mounted(){
    var self = this

    this.slideBody = null
    this.thumbnail = null
    this.$buttonPrev = null
    this.$buttonNext = null
    this.autoSlideTimer = null
    this.autoSlideCountTimer = null

    //auto slide
    this.$data.autoSlide = Number(this.$el.attr("data-auto-slide"))
    let interval = this.$el.attr("data-auto-slide-interval")
    if(interval){
      this.$data.AUTO_SLIDE_INTERVAL = Number(interval)
    }

    //slideBody
    this.slideBody = new SlideShowBody(this.$el.find("[data-role='slideshowContainer']").get(0))
    this.$data.SLIDE_TOTAL_NUM = this.slideBody.$data.SLIDE_TOTAL_NUM
    if (this.$data.SLIDE_TOTAL_NUM <= 1){
      return
    }

    this.slideBody.$el.on("mouseenter", function () {
      self.pauseAutoSlideCount()
      self.clearAutoSlideTimer()
    })
    this.slideBody.$el.on("mouseleave", function () {
      self.startAutoSlideCount()
      self.startAutoSlideTimer()
    })
    this.slideBody.addEventListener("swipeStart", (data) => {
      self.resetAutoSlideCount()
      self.clearAutoSlideTimer()
    })
    this.slideBody.addEventListener("swipeEnd", (data) => {
      // self.startAutoSlideTimer()
    })
    this.slideBody.addEventListener("right", (data) => {
      self.prevSlide()
    })
    this.slideBody.addEventListener("left", (data) => {
      self.nextSlide()
    })

    //4枚以上の場合はPCでもスライドさせる
    if(this.$data.SLIDE_TOTAL_NUM > 3){
      //this.$buttonPrev
      this.$buttonPrev = this.$el.find("[data-role='buttonPrev']")
      this.$buttonPrev.on("click", ()=>{
        this.prevSlide()
      })

      //this.$buttonNext
      this.$buttonNext = this.$el.find("[data-role='buttonNext']")
      this.$buttonNext.on("click", ()=>{
        this.nextSlide()
      })
    }

    //thumbnail
    this.thumbnail = new SlideShowThumbnail(this.$el.find("[data-role='slideShowPagenation']").get(0))
    this.thumbnail.addEventListener("tap", (data) => {
      let prevIndex = self.$data.activeIndex
      if (data - prevIndex > 0) {
        self.$data.slideDir = "left"
      } else {
        self.$data.slideDir = "right"
      }
      self.$data.activeIndex = data
    })
    this.thumbnail.addEventListener("swipeStart", (data) => {
      self.pauseAutoSlideCount()
      self.clearAutoSlideTimer()
    })
    this.thumbnail.addEventListener("swipeEnd", (data) => {
      self.startAutoSlideCount()
      self.startAutoSlideTimer()
    })

    //init

    //event listener
    Device.addEventListener("device_mode", (data) => {
      this.$data.device_mode = data
    })

    this.$data.activeIndex = 0;

    //start auto slide
    this.startAutoSlideTimer()
  }

  /*
  * 前のスライド
  */
  prevSlide(){
    let prevIndex = this.$data.activeIndex - 1
    if(prevIndex < 0 ){
      prevIndex = this.$data.SLIDE_TOTAL_NUM - 1
    }
    this.$data.slideDir = "right"
    this.$data.activeIndex = prevIndex
  }

  /*
  * 次のスライド
  */
  nextSlide(){
    let nextIndex = this.$data.activeIndex + 1
    if (nextIndex >= this.$data.SLIDE_TOTAL_NUM){
      nextIndex = 0
    }
    this.$data.slideDir = "left"
    this.$data.activeIndex = nextIndex
  }

  /*
  * 自動スライド
  */
  autoSlide(){
    if(this.$data.autoSlide === 0){
      return
    }
    this.clearAutoSlideTimer()
    this.nextSlide()
    this.startAutoSlideTimer()
  }
  startAutoSlideTimer(){
    if(this.$data.autoSlide === 0){
      return
    }
    this.clearAutoSlideTimer()
    this.autoSlideTimer = setTimeout(()=>{
      this.autoSlide()
    }, this.$data.AUTO_SLIDE_INTERVAL - this.$data.autoSlideIntervalCount)
  }
  clearAutoSlideTimer(){
    if(this.$data.autoSlide === 0){
      return
    }
    if(this.autoSlideTimer === null){
      return
    }
    clearTimeout(this.autoSlideTimer)
  }
  pauseAutoSlideCount(){
    if(this.$data.autoSlide === 0){
      return
    }
    clearInterval(this.autoSlideCountTimer)
    // this.clearAutoSlideTimer()
  }
  resetAutoSlideCount(){
    if(this.$data.autoSlide === 0){
      return
    }
    clearInterval(this.autoSlideCountTimer)
    this.$data.autoSlideIntervalCount = 0
  }
  startAutoSlideCount(){
    if(this.$data.autoSlide === 0){
      return
    }
    clearInterval(this.autoSlideCountTimer)
    this.autoSlideCountTimer = setInterval(()=>{
      let next = this.$data.autoSlideIntervalCount + this.$data.AUTO_SLIDE_INTERVAL_COUNT_STEP

      if (next > this.$data.AUTO_SLIDE_INTERVAL){
        next = 0
      }
      this.$data.autoSlideIntervalCount = next
    }, this.$data.AUTO_SLIDE_INTERVAL_COUNT_STEP)
  }

}

export default SlideShow
